module.exports = __webpack_public_path__ + "img/banner2.77ad54b3.png";